import { ShipBobTelemetry } from '@shipbob/telemetry'
import router from './router'
import settings from '@/appSettings/appSetting'
import { getTelemetryConfig } from '@/components/micro-front-ends/utils/telemetry'

let telemetry
let unsubscribe

function setTelemetry ($shipBobStore, userDetails) {
  const { host } = getTelemetryConfig($shipBobStore)
  telemetry = new ShipBobTelemetry({
    connectionString: settings.ApplicationInsights.ConnectionString,
    tags: {
      'ai.cloud.role': 'MerchantApp',
      'ai.user.id': userDetails?.id
    },
    customData: {
      host,
      userId: userDetails?.id,
      userEmail: userDetails?._email,
      userImpersonationId: userDetails?.impersonatedUserId,
      userImpersonatedEmail: userDetails?.impersonatedEmail,
      userRole: `${userDetails?.role}`
    },
    config: {
      loggingLevelConsole: 2,
      loggingLevelTelemetry: 2
    },
    router
  })
}

export function initializeTelemetry ($shipBobStore) {
  unsubscribe = $shipBobStore.subscribe(async (mutation, state) => {
    if (mutation.type === 'user/setUser') {
      const userDetails = $shipBobStore?.getters['user/getUser']
      setTelemetry($shipBobStore, userDetails)
      unsubscribe()
    }
  })
}

export function getTelemetryInstance () {
  return telemetry
}

export default telemetry
